import Vue from 'vue'
import Antd from 'ant-design-vue';
import App from './App.vue'
import 'ant-design-vue/dist/antd.css';
import router from './router'
import store from './store'
import './assets/global.scss'
import *as echarts from 'echarts'


Vue.config.productionTip = false
Vue.prototype.$echarts = echarts


Vue.use(Antd);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
